<template>
  <pt-adult-sell-order-progress class="pt-adult-sell-order-progress__page"></pt-adult-sell-order-progress>
</template>

<script>
import PtAdultSellOrderProgress from 'cps/adult-sell-order/pt-adult-sell-order-detail/pt-adult-sell-order-progress/withData'
export default {
  name: 'pt-adult-sell-order-progress__view',
  components: {
    'pt-adult-sell-order-progress': PtAdultSellOrderProgress
  }
}
</script>
